export default __webpack_public_path__ + "static/media/ac-logo-white.cb83fdc2.svg";